import { render, staticRenderFns } from "./CalculoModule.vue?vue&type=template&id=9b97c42c"
import script from "./CalculoModule.vue?vue&type=script&lang=js"
export * from "./CalculoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports